import { IHasUID, ISelectable, LogModel } from 'starbase-launcher';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';

export enum LogLevel {
  Debug,
  Information,
  Warning,
  Error,
  Fatal
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export class Log_ext extends LogModel implements ISelectable {
  public selected: boolean;

  public static LogColumns(showUID = false, showGuid = true, showExceptions = false): ITableColumn[] {
    const uidCol = new TableColumn('uid', 'UID', ColumnDataTypes.number);
    uidCol.visible = showUID;
    const guidCol = new TableColumn('entityGuid', 'Guid', ColumnDataTypes.string);
    guidCol.visible = showGuid;
    guidCol.allowSort = false;
    const excCol = new TableColumn('exception', 'Exception');
    excCol.visible = showExceptions;
    return [
      uidCol,
      guidCol,
      new TableColumn('timeStamp', 'Datetime', ColumnDataTypes.datetime),
      new TableColumn('message', 'Message'),
      new TableColumn('level', 'Level'),
      excCol,
      new TableColumn('category', 'Category'),
      new TableColumn('action', 'Action'),
      new TableColumn('user', 'User'),
      new TableColumn('entityName', 'Entity')
    ];
  }
}

export enum UserType {
  Trial = 1,
  Monthly = 2,
  Annual = 3,
  Student = 4,
  Librarian = 5,
  Admin = 6,
  Free = 7,
  Other = 8
}

export class UserConnectionlogModel implements IHasUID {
  uid: number;
  timeStamp: Date;
  connectionId: string;
  userId: number;
  userName: string;
  isSubscriber: boolean;
  userType: UserType;
  sessionStart: Date;
  sessionEnd: Date;
  sessionDuration: number;
}
